import { IconProps } from '@models/icons';

function ToastSuccess({ size = 24, color = '#6AC917', ...rest }: IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <circle cx="12.5" cy="12" r="6" fill={color}/>
            <path d="M10.0208 11.7083L11.7708 13.75L14.9792 10.25"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
  );
}

export default ToastSuccess;
